<template>
  <img
    v-if="code?.length === 3"
    class="self-center"
    :alt="!!country ? `${$t('Change language to')} ${country}` : `Change language to ${code}`"
    :src="getFlagSrc(code)"
    :class="
      big ? 'w-6 rectangle-full object-cover object-[50%_-0px]' : 'w-5 rectangle-full object-cover object-[50%_-0px]'
    " />
</template>
<script setup>
defineProps({
  code: { required: true, type: String },
  big: Boolean,
  country: { required: false, type: String, default: "" },
});

import config from "@/config";
const getFlagSrc = (code) => `${config.FLAGS_BASE_URL}/${code}.svg`;
</script>
